import {get} from 'lodash/fp'
import React, {Component} from 'react'

import {countries, countriesById} from '../../data/countries'
import Select from '../../components/Select'
import Button from '../../components/Button'

import './styles.css'

class NonUS extends Component {
  state = {
    country: '',
  }

  onCountryChange = country => this.setState({country})
  onCountrySelected = () => {
    const {country} = this.state
    const {onCountrySelected} = this.props
    onCountrySelected(country)
  }

  render() {
    const {country} = this.state
    const hasCountry = country !== ''
    const countryHasEmissions = get([country, 'co2'], countriesById)
    return (
      <div className='non-us'>
        <div className='non-us-text'>
          Our first climate impact questionnaire is for the United States. We hope to secure the resources and data needed to create questionnaires for more countries.
        </div>
        <div className='non-us-text'>
          In the meantime, you can find out the most up-to-date estimate of an individual's annual climate impact in your country.
        </div>
        <Select
          onChange={this.onCountryChange}
          className='non-us-select'
          options={countries}
          value={country}
          placeholder='Select Your Country...'
        />
        {hasCountry && countryHasEmissions &&
          <div className='non-us-begin'>
            <Button onClick={this.onCountrySelected}>
              See Impact
              <i className='fa fa-angle-double-right non-us-arrow'/>
            </Button>
          </div>
        }
        {hasCountry && !countryHasEmissions &&
          <div className='non-us-text'>
            We are sorry. There currently isn't sufficient data for your country!
          </div>
        }
      </div>
    )
  }
}

export default NonUS



// WEBPACK FOOTER //
// ./src/apps/NonUS/index.js